import * as React from "react";

import { cn } from "@/lib/utils";

const Input = React.forwardRef<HTMLInputElement, React.ComponentProps<"input">>(
  ({ className, type, ...props }, ref) => {
    return (
      <input
        type={type}
        className={cn(
          "flex h-12 w-full glass-liquid-light border-border-glass-medium px-4 py-3 text-base font-inter",
          "placeholder:text-muted-foreground/60",
          "focus-visible:outline-none focus-visible:glass-liquid-medium focus-visible:ring-2 focus-visible:ring-primary/30 focus-visible:border-primary/50",
          "disabled:cursor-not-allowed disabled:opacity-50",
          "liquid-morph rounded-2xl shadow-liquid-sm focus-visible:shadow-liquid-md",
          className,
        )}
        ref={ref}
        {...props}
      />
    );
  },
);
Input.displayName = "Input";

export { Input };
